import { createContext } from 'react';
import { Koala } from 'assets/images';

export const AppContext = createContext({
  profileAvatar: Koala,
});
